import { render, staticRenderFns } from "./ItemRules.vue?vue&type=template&id=812d303c&"
import script from "./ItemRules.vue?vue&type=script&lang=js&"
export * from "./ItemRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports